exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications-wrapper > .content > .notifications > .notification:not('.alert-plain') > h4 > a,\n.notifications-wrapper > .content > .notifications > .notification:not('.alert-plain') > span > a {\n  color: rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  transition: 0.3s all ease;\n  text-decoration: underline;\n}\n.notifications-wrapper > .content > .notifications > .notification:not('.alert-plain') > h4 > a:hover,\n.notifications-wrapper > .content > .notifications > .notification:not('.alert-plain') > span > a:hover {\n  color: #fff;\n}\n", ""]);

// exports
